var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('i',{staticClass:"download_center",class:_vm.isStore ? 'store_download_center' : '',style:({ top: _vm.top }),on:{"click":_vm.go_index}},[(_vm.isStore)?_c('span',{staticClass:"text"},[_vm._v("\n    "+_vm._s(_vm.storeAgentCenterName)+"\n  ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }